import type { ISerialize } from '@/objects/ISerialize';

export class TrackingDeviceStateStatus implements ISerialize {
    public DevicesFailed: number;

    public DevicesSet: number;

    public TotalDevices: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { DevicesFailed?: number; DevicesSet?: number; TotalDevices?: number }) {
        this.DevicesFailed = values.DevicesFailed ?? 0;

        this.DevicesSet = values.DevicesSet ?? 0;

        this.TotalDevices = values.TotalDevices ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"DevicesFailed": ${JSON.stringify(this.DevicesFailed)}` +
            ',' +
            `"DevicesSet": ${JSON.stringify(this.DevicesSet)}` +
            ',' +
            `"TotalDevices": ${JSON.stringify(this.TotalDevices)}` +
            '}'
        );
    }

    /**
     * Creates an instance of TrackingDeviceStateStatus from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { DevicesFailed?: number; DevicesSet?: number; TotalDevices?: number }): TrackingDeviceStateStatus {
        return new TrackingDeviceStateStatus(values);
    }

    public static _FromServerJson(json: any): TrackingDeviceStateStatus {
        return new TrackingDeviceStateStatus({
            DevicesFailed: json.DevicesFailed,
            DevicesSet: json.DevicesSet,
            TotalDevices: json.TotalDevices,
        });
    }

    /**
     * Creates an instance of TrackingDeviceStateStatus from another instance of TrackingDeviceStateStatus.
     * @param other The TrackingDeviceStateStatus you want to clone
     * @returns A cloned TrackingDeviceStateStatus
     */
    public static FromOther(other: TrackingDeviceStateStatus): TrackingDeviceStateStatus {
        return TrackingDeviceStateStatus._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TrackingDeviceStateStatus.FromOther(this);
    }

    static NAME_OF_CLASS = 'TrackingDeviceStateStatus';
}
